import Vue from 'vue';
import swal from 'sweetalert';
import Jaw3DConstants from './jaw3d-constants.js';

export let addEventLnr = (obj, type, fn) => {
    if (window.attachEvent) {
        obj["e" + type + fn] = fn;
        obj[type + fn] = function () { obj["e" + type + fn](window.event); };
        obj.attachEvent("on" + type, obj[type + fn]);
    } else {
        obj.addEventListener(type, fn, false);
    }
};

export let addEventDsptchr = (eName) => { 
    if (window.Event && typeof window.Event === "function") {
        return new Event(eName);
    } else {
        let event = document.createEvent('Event');
        event.initEvent(eName, true, true);
        return event;
    }
};

export let extend = (base, newObj) => {
    let key,
        obj = JSON.parse(JSON.stringify(base));
    
    if (newObj) { 
        for(key in newObj) {
            if (Object.prototype.hasOwnProperty.call(newObj, key) && 
                Object.prototype.hasOwnProperty.call(obj, key)) {
                    obj[key] = newObj[key];
            }
        }
    }
    return obj;
};

export let checkWebGL = () => {
    return window.CanvasRenderingContext2D &&
    (function () {
        try {
            var canvas = document.createElement("canvas"); 
            return !! (window.WebGLRenderingContext && 
                (canvas.getContext("webgl") || canvas.getContext("experimental-webgl")));
        } catch ( e ) {
            return false;
        }
    })();
}

export let  sortNumber = (a, b) => { return a - b; } 

export let connerctorName = (obj1, obj2) => {
    return ([obj1, obj2]).sort(sortNumber).join("_");
};

export const isToothNumberInRange = (toothNumber, startNumber, endNumber) => {
    const p1 = Jaw3DConstants.FdiNumbers.indexOf(Number(toothNumber));
    const p2 = Jaw3DConstants.FdiNumbers.indexOf(Number(startNumber));
    const p3 = Jaw3DConstants.FdiNumbers.indexOf(Number(endNumber));
    const jawSize = Jaw3DConstants.FdiNumbers.length / 2;
    if (p1 < 0) {
        swal('', Vue.$t('Configurator.invalidTeethNumber', [toothNumber]), 'error');
        return false;
    }
    else if (p2 < 0) {
        swal('', Vue.$t('Configurator.invalidTeethNumber', [startNumber]), 'error');
        return false;
    }
    else if (p3 < 0) {
        swal('', Vue.$t('Configurator.invalidTeethNumber', [endNumber]), 'error');
        return false;
    }
    else if ((p2 < jawSize && p3 >= jawSize) || (p2 >= jawSize && p3 < jawSize)) {
        swal('', Vue.$t('Configurator.invalidRange', [startNumber, endNumber]), 'error');
        return false;
    }
    return (p1 >= p2 && p1 <= p3) || (p1 <= p2 && p1 >= p3);
};
